import { render, staticRenderFns } from "./stdbasic.vue?vue&type=template&id=b8a497fa&scoped=true&"
import script from "./stdbasic.vue?vue&type=script&lang=js&"
export * from "./stdbasic.vue?vue&type=script&lang=js&"
import style0 from "./stdbasic.vue?vue&type=style&index=0&id=b8a497fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a497fa",
  null
  
)

export default component.exports